import { Controller } from "@hotwired/stimulus"

// The order picker on the inbound webhook form (#16819): the agent builds a new
// order (and names it) or picks one they already built. Only orders of the
// webhook's lead type are offered, and the name box shows only for "Build a
// new order". The server re-checks both (InboundWebhook#lead_order_chosen), so
// this is guidance, never the rule.
export default class extends Controller {
  static targets = ["leadType", "order", "nameField"]
  static values = { newOrder: { type: String, default: "new" } }

  connect() {
    this.sync()
  }

  sync() {
    const leadType = this.leadTypeTarget.value
    Array.from(this.orderTarget.options).forEach((option) => {
      const optionType = option.dataset.leadType
      if (!optionType) return

      const offered = optionType === leadType
      option.hidden = !offered
      option.disabled = !offered
    })

    const selected = this.orderTarget.selectedOptions[0]
    if (selected && selected.disabled) this.orderTarget.value = ""

    const building = this.orderTarget.value === this.newOrderValue
    this.nameFieldTarget.hidden = !building
    this.nameFieldTarget.querySelectorAll("input").forEach((input) => {
      input.required = building
    })
  }
}
